/**
 * Site-wide typeface presets.
 */
export const FONT_PRESETS = [
  {
    id: "plex-mono",
    label: "IBM Plex Mono",
    body: '"IBM Plex Mono", monospace',
    display: '"IBM Plex Mono", monospace',
  },
  {
    id: "space-grotesk",
    label: "Space Grotesk",
    body: '"Space Grotesk", sans-serif',
    display: '"Space Grotesk", sans-serif',
  },
];

export const DEFAULT_FONT_ID = "plex-mono";

export function getFontPreset(id) {
  return (
    FONT_PRESETS.find((preset) => preset.id === id) ||
    FONT_PRESETS.find((preset) => preset.id === DEFAULT_FONT_ID)
  );
}
